export const SET_FETCHED_BUNDLES = 'component-repository/hub/set-fetched-bundles';
export const SET_ACTIVE_REGISTRY = 'component-repository/hub/set-active-registry';
export const SET_FETCHED_REGISTRIES = 'component-repository/hub/set-fetched-registries';
export const SET_FETCHED_BUNDLE_GROUPS = 'component-repository/hub/set-fetched-bundle-groups';
export const SET_BUNDLE_STATUSES = 'component-repository/hub/set-bundle-statuses';
export const SET_SELECTED_BUNDLE_STATUS = 'component-repository/hub/set-selected-bundle-status';
export const SET_BUNDLE_GROUP_ID_FILTER = 'component-repository/hub/set-bundle-group-id-filter';
